import React from 'react';
import './Footer.css'; // Moved styles to a CSS file

const Footer = () => {
    return (
        <footer className="footer">
            <p className="footer-text">© {new Date().getFullYear()} Your Company Name. All rights reserved.</p>
        </footer>
    );
};

export default Footer;